/* eslint-disable @typescript-eslint/no-empty-function */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Card,
  Col,
  Dropdown,
  InputNumber,
  Menu,
  message,
  Modal,
  notification,
  Row,
  Space,
  Table,
  Tabs,
  Badge,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { TabPane } from '../../compnents/widgets/TabBar'
import { getTradeCode, Material } from '../../models/material'
import {
  getTemplateCategoryName,
  PrintTemplateCategory,
} from '../../models/print'
import {
  getRecipeCategoryName,
  isRecipePayable,
  isTcmRecipeCategory,
  Recipe,
  RecipeCategory,
  RecipeStatus,
} from '../../models/recipe'
import { Treatment, TreatmentNotice } from '../../models/treatment'
import { PayTypeBodyBatch, replaceMakeInfoParams } from '../../services/recipe'
import { ThemeContext } from '../../theme/ThemeContext'
import { useQuery } from '../../utils/HttpUtils'
import { PrintTemplateModal } from '../print/PrintTemplateModal'
import {
  DisposeColumns,
  MedicineMaterialColumns,
  TcmColumns,
} from '../treatment/editor/columns'
import {
  createOrUpdateRecipe,
  getInsuranceToSelfpay,
  getPrintZXDData,
  getReplaceMakeInfo,
  isdeleteReplaceMakeSetting,
  selectRecipe,
  updateItemPayTypeBatchAsync,
} from '../treatment/editor/recipeEditorSlice'
import {
  editST,
  getTreatmentNotice,
  saveToothAsync,
  syncToothAsync,
  updateItemPayTypeAsync,
} from '../treatment/editor/recipeListEditorSlice'
import { ReplaceMakeSettingModal } from '../treatment/editor/modals/ReplaceMakeSettingModal'
import styles from './RecipeList.module.css'
import {
  getMaterialList,
  getRecipeList,
  getTreatment,
  removeMaterials,
  selectMaterialList,
  selectPageLoading,
  selectRecipeList,
  setMaterials,
  setPageLoading,
} from './recipeListSlice'
import { setUpdateFlagsAsync } from '../payment/confirm/paymentConfirmSlice'
import { setTreatmentId } from '../retail/retailSlice'
import _ from 'lodash'
import {
  ExclamationCircleFilled,
  MinusOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import {
  selectApiUserType,
  selectEdition,
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import { DecoctingSettingModal } from '../treatment/editor/modals/DecoctingSettingModal'
import { DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import {
  getPatientInfoAsync,
  medicalRegisterAsync,
} from '../registration/register/registerSlice'
import {
  getTradeName,
  medicalSendHttp,
  readCardEHttp,
  readCardSHttp,
  strParse,
} from '../../utils/MedicalUtils'
import { DefaultUseMethod } from '../../models/recipeusemethod'
import { getDetailWithTreatmentIDAndNoSettleAsync } from '../PharmacyRetail/PharmacyRetailSlice'
import { TraceCodeInputModal } from '../payment/list/TraceCodeInputModal'
import { getTraceCodeCntByTreatmentIdAsync } from '../payment/list/TraceCodeInputSlice'

interface RecipeListProps {
  noCheckBox?: any
  readMode?: boolean
  yidibz?: string
  treatmentId?: string
  onSelect?: (recipes: Recipe[]) => void
  onSelectCurrentRecipe?: (v?: any) => void
  showCodeInputModalFlag?:(v?: any) => void
  style?: React.CSSProperties
  onNotice?: (notice: TreatmentNotice) => void
  autoSelect?: boolean
}

export const RecipeList = ({
  noCheckBox,
  readMode = false,
  yidibz,
  treatmentId,
  onSelect,
  onSelectCurrentRecipe,
  showCodeInputModalFlag,
  style,
  onNotice,
  autoSelect = false,
}: RecipeListProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const insuranceArray = useSelector(selectInsuranceArray)

  // const recipes = useSelector(selectRecipeList)

  const materials = useSelector(selectMaterialList)

  const userId = useSelector(selectUserId)

  const userName = useSelector(selectUserName)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantName = useSelector(selectTenantName)

  const tenantCategory = useSelector(selectTenantCategory)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const cycleCode = sessionStorage.getItem('cycleCode')
  const apiUserType = useSelector(selectApiUserType)

  const [treatment, setTreatment] = useState<Treatment | undefined>()

  const [currentRecipe, setCurrentRecipe] = useState<Recipe | undefined>()

  const [currentRecipeId, setCurrentRecipeId] = useState<any>()

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
    PrintTemplateCategory | undefined
  >()

  const [recipeUseMethod, setRecipeUseMethod] = useState<string[]>(
    DefaultUseMethod
  )

  const [selectedRecipes, setSelectedRecipes] = useState<Recipe[]>([])

  const [selectedMaterialIds, setSelectedMaterialIds] = useState<string[]>([])

  const [registrationForConvert, setRegistrationForConvert] = useState<
    any | null
  >()

  const [readCardLoading, setReadCardLoading] = useState(false)

  const [
    updateItemTypeBatchReadLoading,
    setUpdateItemTypeBatchReadLoading,
  ] = useState(false)

  const query = useQuery()

  const [isReplaceMakeModalVisible, setIsReplaceMakeModalVisible] = useState(
    false
  )

  const treatmentIds = query.get('treatmentId') as string

  const [isSetting, setIsSetting] = useState(false) // 是否设置过代煎

  const [isSettledFlag, setIsSettledFlag] = useState<any>()

  const [outRecipeDisable, setOutRecipeDisable] = useState(false)

  const [machiningTypeMsg, setMachiningTypeMsg] = useState('') //加工类别信息

  const [replaceMakeDisable, setReplaceMakeDisable] = useState(true) // 代煎按钮是否禁用

  const [setID, setSetId] = useState(0)

  const [recipes, setReciptList] = useState<any>()

  const [replaceMakeId, setreplaceMakeId] = useState<any>('')

  const [isOpenReplaceMake, setIsOpenReplaceMake] = useState(false) //是否开通代煎

  const [potionType, setpotionType] = useState(0) //上次的代煎方式

  const [isDisableReplaceMake, setisDisableReplaceMake] = useState(false)

  const [isOpenPriceRatio, setIsOpenPriceRatio] = useState(false)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const [tipCount, setTipCount] = useState<any>(7)

  const pageLoading = useSelector(selectPageLoading)

  const [showCodeInputModal, setShowCodeInputModal] = useState(false)

  const [recipeItemList, setRecipeItemList] = useState<any[]>()

  const [traceCodeCnt, setTraceCodeCnt] = useState<any>(0)
  
  const [expiredInDaysEyeFlag, setExpiredInDaysEyeFlag] = useState<any>('1')
  
  const expiredInDaysEyeFlags: any = localStorage.getItem('expiredInDaysEyeFlag')
  
  useEffect(() => {
    localStorage.setItem('expiredInDaysEyeFlag', expiredInDaysEyeFlags ? expiredInDaysEyeFlags : '1')
  }, [])
  
  useEffect(() => {
    setExpiredInDaysEyeFlag(expiredInDaysEyeFlags ? expiredInDaysEyeFlags : expiredInDaysEyeFlag || 1)
  }, [])
    

  useEffect(() => {
    if (!registrationForConvert) {
      setReadCardLoading(false)
    }
  }, [registrationForConvert])

  const getDetail = () => {
    dispatch(getTreatment(treatmentId || ''))
  }

  useEffect(() => {
    if (currentRecipe) {
      if (currentRecipe.useMethod) {
        setRecipeUseMethod(currentRecipe.useMethod?.split(',') || [])
      }
      if (isTcmRecipeCategory(currentRecipe?.category)) {
        setRecipeUseMethod(DefaultUseMethod)
        setTipCount(Number(currentRecipe?.tip) || 7)
      } else {
        setRecipeUseMethod([])
        setTipCount(1)
      }
    }
  }, [currentRecipe])

  useEffect(() => {
    if (
      recipeUseMethod &&
      recipeUseMethod[1] === '外用' &&
      recipeUseMethod[2]?.length > 0 &&
      recipeUseMethod[3]?.length > 0
    ) {
      setRecipeUseMethod([recipeUseMethod[0], recipeUseMethod[1], '', ''])
    }
  }, [recipeUseMethod])

  const setUpdateFlags = (insuranceFlag: string, updateFlag: string) => {
    dispatch(
      setUpdateFlagsAsync({
        treatmentId,
        insuranceFlag,
        updateFlag,
      })
    )
      .then(unwrapResult)
      .then(() => {
        getDetail()
      })
  }

  useEffect(() => {
    // 处于中药或者颗粒剂且有数据的时候才显示代煎相关配置
    setReplaceMakeDisable(materials.length === 0)
  }, [materials])

  useEffect(() => {
    if (isSetting) {
      const replaceMake = materials.find((v: any) => v.billingCategory === '97')
      setreplaceMakeId(replaceMake?.id)
    }
  }, [isSetting, materials])

  useEffect(() => {
    if (!isReplaceMakeModalVisible) {
      if (
        (currentRecipe?.category === 3 || currentRecipe?.category === 12) &&
        materials.length !== 0
      ) {
        const data: replaceMakeInfoParams = {
          decoctionType: currentRecipe?.category === 3 ? 0 : 1,
          tenantRecipeId: currentRecipe?.id,
        }
        dispatch(getReplaceMakeInfo({ ...data }))
          .then(unwrapResult)
          .then((res: any) => {
            setSetId(res.settingId)
            setIsSetting(res.status === 1)
            setMachiningTypeMsg(res.machiningTypeMsg)
            setIsOpenReplaceMake(res.openType === 0)
            setpotionType(res.potionType)
            setIsOpenPriceRatio(res.openPriceRatio == 0)
          })
      } else {
        setIsSetting(false)
      }
    }
  }, [currentRecipe, materials, isReplaceMakeModalVisible])

  const getRecipeListData = () => {
    dispatch(getRecipeList(treatmentId || treatmentIds))
      .then(unwrapResult)
      .then((v: any) => {
        setReciptList(v)
      })
  }

  useEffect(() => {
    setOutRecipeDisable(treatment?.treatmentType == '1')
  }, [treatment])

  useEffect(() => {
    if (treatmentId || treatmentIds) {
      getTreatmentData()
    }
  }, [treatmentId, treatmentIds])

  const getTreatmentData = () => {
    getRecipeListData()
    dispatch(getTreatment(treatmentId || treatmentIds))
      .then(unwrapResult)
      .then((treatment) => {
        setTreatment(treatment)
        return treatment.patientId
      })
      .then((patientId) =>
        dispatch(getTreatmentNotice(patientId)).then(unwrapResult)
      )
      .then((notice) => onNotice && onNotice(notice))
      .catch(() => {
        // do nothing.
      })

    getTraceCodeCnt()
  }

  const getTraceCodeCnt = () => {
    dispatch(getTraceCodeCntByTreatmentIdAsync(treatmentId || treatmentIds))
      .then(unwrapResult)
      .then((cnt) => {
        setTraceCodeCnt(cnt)
      })
  }

  useEffect(() => {
    setCurrentRecipe(undefined)
    const list = recipes?.filter((v: any) => v?.id == currentRecipe?.id)
    if (recipes?.length >= 0) {
      if (currentRecipe?.id) {
        setCurrentRecipe(list[0])
      } else {
        setCurrentRecipe(recipes[0])
      }
      if (autoSelect) {
        setSelectedRecipes(recipes.filter(isRecipePayable))
      }
    }
  }, [recipes])

  const getReciptPrintList = () => {
    dispatch(getPrintZXDData(currentRecipe?.id))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  useEffect(() => {
    dispatch(setMaterials([]))
    if (currentRecipe && !isReplaceMakeModalVisible) {
      dispatch(setPageLoading(true))
      setTimeout(() => {
        dispatch(setPageLoading(false))
      }, 5000)
      dispatch(getMaterialList(currentRecipe.id))
    }
  }, [currentRecipe, isReplaceMakeModalVisible])

  useEffect(() => {
    onSelect && onSelect(selectedRecipes)
  }, [selectedRecipes])

  useEffect(() => {
    onSelectCurrentRecipe && onSelectCurrentRecipe(currentRecipe)
  }, [currentRecipe])

  const selectedRecipesZY: any = recipes?.filter(
    (v: any) => v?.id == currentRecipe?.id
  )

  const fValue: any =
    (selectedRecipesZY?.[0]?.recipeNormalFrequency
      ? ',' + selectedRecipesZY?.[0]?.recipeNormalFrequency
      : '') +
    (selectedRecipesZY?.[0]?.recipeNormalUsemethod
      ? ',' + selectedRecipesZY?.[0]?.recipeNormalUsemethod
      : '') +
    (selectedRecipesZY?.[0]?.recipeNormalDose
      ? ',' + selectedRecipesZY?.[0]?.recipeNormalDose
      : '') +
    (selectedRecipesZY?.[0]?.remark ? ',' : '')

  const fRemark = selectedRecipesZY?.[0]?.remark
    ? selectedRecipesZY?.[0]?.remark
    : ''

  const changeItemsPayType = (
    <Menu
      onClick={(item) => {
        if (!selectedMaterialIds || selectedMaterialIds.length <= 0) {
          notification.error({
            message: '请选择至少一条明细',
          })
          return
        }
        setUpdateItemTypeBatchReadLoading(true)
        const param: PayTypeBodyBatch = {
          treatmentId: Number(treatmentId),
          itemPayType: item.key,
          recipeItemIds: selectedMaterialIds,
        }
        dispatch(updateItemPayTypeBatchAsync(param))
          .then(unwrapResult)
          .then(() => {
            dispatch(getMaterialList(currentRecipe?.id || ''))
              .then(unwrapResult)
              .then(() => {
                setSelectedMaterialIds([])
                notification.success({
                  message: '操作成功',
                })
                setUpdateItemTypeBatchReadLoading(false)
              })
          })
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
        医保
      </Menu.Item>
      <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
        历年
      </Menu.Item>
      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )

  const success = (str: string) => {
    message.loading(str, 3)
  }

  const successBytype = (str: string, type: number) => {
    if (type === 1) {
      setReadCardLoading(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadCardLoading(false)
      }, 3000)
    } else if (type === 2) {
      setReadCardLoading(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadCardLoading(false)
      }, 3000)
    } else if (type === 3) {
      setReadCardLoading(true)
      const hide = message.loading(str, 0)
      setTimeout(() => {
        hide()
        setReadCardLoading(false)
      }, 3000)
    }
  }

  const readCard = (cardType: 1 | 2 | 3 | 11) => {
    if (cardType == 1) {
      successBytype('读卡中', 1)
      readETypeToyb()
    } else if (cardType == 2) {
      // setOtherPatientInsuranceItem({}) // 防止误用他人信息
      // readCardRef.current.blur() //按钮失焦，防止重复点击
      // // const readType = form.getFieldsValue().readType
      // success('读卡中', 2)
      // const idCardNumber = form.getFieldsValue().idCardNumber
      // if (idCardNumber) {
      //     getPatientInfo(idCardNumber, 'requestString')
      // } else {
      //     notification.info({
      //         message: '请输入身份证号',
      //     })
      // }
    } else if (cardType === 3) {
      successBytype('读卡中', 3)
      readSType()
    } else if (cardType === 11) {
      successBytype('读卡中', 1)
      readFaceTypeToyb()
    }
  }

  // 实体卡读卡
  const readSType = () => {
    readCardSHttp(
      {
        trade_args: [getTradeCode(tenantAreaCd.slice(0, 4))],
      },
      (data, err) => {
        if (!err) {
          const tradeType = getTradeName()
          const Name =
            tradeType === 'JS_ZHYB'
              ? data?.netmessage
                  ?.split('|')[4]
                  ?.replace('\r', '')
                  .replace('\t', '')
                  .replace(' ', '')
                  .trim()
              : data?.netmessage?.Name
          if (Name == registrationForConvert?.patientName) {
            getPatientInfoAndConvertToYb(
              tradeType === 'JS_ZHYB'
                ? data.netmessage
                : JSON.stringify(data.netmessage),
              '0',
              '0',
              'requestString',
              3
            )
          } else {
            Modal.error({
              title: '提示',
              content:
                `患者姓名与卡片姓名不一致，请确认是否插错卡，就诊人：` +
                registrationForConvert?.patientName +
                '，卡片姓名：' +
                Name,
              okText: '确认',
            })
            setReadCardLoading(false)
          }
        } else {
          setReadCardLoading(false)
        }
      }
    )
  }
  // 电子凭证读卡
  const readFaceTypeToyb = () => {
    readCardEHttp(
      {
        trade_args: [
          insuranceArray[0].countryHospitalNb,
          '01301',
          'cn.nhsa.ec.auth',
          userId,
          userName,
          '',
          '',
        ],
      },
      (data, err) => {
        if (!err) {
          const readName = data?.netmessage?.split('|')[0]?.trim()
          const patientName = registrationForConvert?.patientName?.trim()
          if (readName != patientName) {
            Modal.error({
              title: '提示',
              content:
                `病人信息与刷脸信息不一致，请确认是否插错卡，就诊人：` +
                patientName +
                '，人脸对应姓名：' +
                readName,
              okText: '确认',
            })

            console.log('readName:', readName, ' 长度：', readName?.length)
            console.log('patientName:', patientName, ' 长度：', patientName?.length)
            // 打印字符编码以便调试
            console.log('readName charCodes:', readName?.split('').map((c: string) => c.charCodeAt(0)))
            console.log('patientName charCodes:', patientName?.split('').map((c: string) => c.charCodeAt(0)))
            setReadCardLoading(false)
          } else {
            getPatientInfoAndConvertToYb(
              data.netmessage,
              data?.QrCode,
              data?.ChnlId,
              'requestString',
              1
            )
          }
        } else {
          setReadCardLoading(false)
        }
      }
    )
  }
  // 电子凭证读卡
  const readETypeToyb = () => {
    readCardEHttp(
      {
        trade_args: [
          insuranceArray[0].countryHospitalNb,
          '01301',
          '',
          userId,
          userName,
          '',
          '',
        ],
      },
      (data, err) => {
        if (!err) {
          const readName = data?.netmessage?.split('|')[0]
          if (readName != registrationForConvert?.patientName) {
            Modal.error({
              title: '提示',
              content:
                `病人信息与卡片信息不一致，请确认是否插错卡，就诊人：` +
                registrationForConvert?.patientName +
                '，电子凭证姓名：' +
                readName,
              okText: '确认',
            })
            setReadCardLoading(false)
          } else {
            getPatientInfoAndConvertToYb(
              data.netmessage,
              data?.QrCode,
              data?.ChnlId,
              'requestString',
              1
            )
          }
        } else {
          setReadCardLoading(false)
        }
      }
    )
  }

  // 获取参保人信息
  const getPatientInfoAndConvertToYb = (
    fullCardInfo: string,
    qrcode: string,
    chnlid: string,
    serverType: any,
    cardType: number,
    responseString?: string
  ) => {
    dispatch(
      getPatientInfoAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceArray[0],
            endTime: moment(insuranceArray[0].endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          registrationId: registrationForConvert?.id,
          cardType: String(cardType) == "11" ? '1' : String(cardType),
          fullCardInfo,
          otherMap: {},
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceArray[0].countryHospitalNb,
                insuranceArray[0].secretToken,
              ],
            },
            (call: any, err) => {
              if (!err) {
                successBytype('正在获取人员信息', cardType)
                getPatientInfoAndConvertToYb(
                  fullCardInfo,
                  qrcode,
                  chnlid,
                  'response',
                  cardType,
                  JSON.stringify(call.netmessage)
                )
                // }
              } else {
                setReadCardLoading(false)
              }
            }
          )
        } else {
          message.success('读卡成功', 0)
          //紧跟着做一次医保挂号
          medicalSubmitAndConvertToYb(
            res,
            fullCardInfo,
            qrcode,
            chnlid,
            cardType,
            'requestString'
          )
        }
      })
      .catch((ex: any) => {
        notification.error({
          message: ex.message,
          duration: 3,
        })
        setReadCardLoading(false)
      })
  }

  const medicalSubmitAndConvertToYb = (
    patientInsurance: any,
    fullCardInfo: any,
    qrcode: string,
    chnlid: string,
    cardType: number,
    serverType: any,
    responseString?: string
  ) => {
    dispatch(
      medicalRegisterAsync({
        serverType,
        body: {
          baseData: {
            ...insuranceArray[0],
            endTime: moment(insuranceArray[0].endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
            responseString: responseString ? responseString : null,
          },
          begntime: moment().format(DateTimeFormatSimpleOnlyOne),
          cardType: String(cardType),
          fullCardInfo: fullCardInfo,
          patientId: registrationForConvert?.patientId,
          registrationId: registrationForConvert?.id,
          treatmentId: registrationForConvert?.treatmentId,
          patientName: registrationForConvert?.patientName,
          pi: {
            ...patientInsurance?.patientInsurance,
            dzpzQrCode: qrcode,
            dzpzChnlId: chnlid,
          },
          // cbxz: patientInsurance.cbxz,
          // doctorCode: doctorItem?.countryCode,
          // doctorName: doctorItem?.name,`
          // gwybz: patientInsurance.gwybz,
          // insuranceRegion: patientInsurance.insuranceRegion,
          // psnType: patientInsurance.memberType,
          // treatmentDepartmentCode: treatmentItem.code,
          // treatmentDepartmentName: treatmentItem.name,
          // treatmentNo: treatmentNum,
          // ybKebie: treatmentItem.ybKebie,
          // ybPersonalNo: vs.ybPersonalNo,
          // name: patientInsurance.name,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: any) => {
        setReadCardLoading(true)
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceArray[0].countryHospitalNb,
                insuranceArray[0].secretToken,
              ],
              massage: '医保挂号',
            },
            (call: any, err) => {
              if (!err) {
                medicalSubmitAndConvertToYb(
                  patientInsurance,
                  fullCardInfo,
                  qrcode,
                  chnlid,
                  cardType,
                  'response',
                  JSON.stringify(call.netmessage)
                )
              } else {
                setReadCardLoading(false)
              }
            }
          )
        } else {
          notification.success({
            message: '自费转医保成功，请继续操作。',
            duration: 2,
          })
          setReadCardLoading(false)
          setRegistrationForConvert(null)
          getTreatmentData()
        }
      })
      .catch((ex: any) => {
        notification.error({
          message: ex.message,
          duration: 2,
        })
        setReadCardLoading(false)
      })
  }

  return (
    <Row
      wrap={false}
      style={{ overflow: 'hidden', ...style }}
      className={styles.container}
    >
      <Col
        style={{
          width: 290,
          height: '100%',
          flexShrink: 0,
          display: 'flex',
          backgroundColor: theme.pn,
          borderRadius: readMode ? `0 0 0 ${theme.br}px` : `${theme.br}px`,
        }}
      >
        <Tabs
          centered
          style={{ width: '100%', height: '100%' }}
          tabBarStyle={{
            borderBottom: `1px solid ${theme.th}`,
            marginBottom: 20,
          }}
          className={styles.tabs}
        >
          <TabPane
            tab={<span style={{ fontSize: '1.25rem' }}>处方信息</span>}
            key='0'
            style={{ height: '100%' }}
          >
            <Col
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              {/* {yidibz && Number(yidibz) > 0 && (
                <div style={{ color: 'gray', marginLeft: '20px' }}>
                  *异地患者不允许分次结算
                </div>
              )} */}
              <Table<Recipe>
                className={styles.table}
                rowClassName={(r: any) =>
                  // r.id === currentRecipe?.id
                  //   ? styles.selected
                  //   : r.state !== RecipeStatus.ToSettle &&
                  //     r.state !== RecipeStatus.Unknown &&
                  //     r.state !== RecipeStatus.Returned
                  //   ? styles.settled
                  //   : ''
                  r.id == currentRecipe?.id
                    ? r.state === RecipeStatus.Settled
                      ? styles.settledSelected
                      : r.state === RecipeStatus.Returned
                      ? styles.returnedSelected
                      : ''
                    : styles.elseSelected
                }
                columns={[
                  {
                    title: '类型',
                    key: 'category',
                    render: (_, r) => {
                      const isSelected = r.id == currentRecipe?.id
                      const isSettled =
                        r.state === RecipeStatus.Settled ||
                        r.state === RecipeStatus.Returned
                      const isSettledFlag = r.state === RecipeStatus.Settled
                      const isReturnedFlag = r.state === RecipeStatus.Returned
                      setIsSettledFlag(isSettled)
                      setisDisableReplaceMake(isSettled)
                      return {
                        props: {
                          style: {
                            color: isSelected
                              ? isSettledFlag
                                ? theme.s
                                : isReturnedFlag
                                ? '#ccc'
                                : theme.c1
                              : isSettledFlag
                              ? theme.s
                              : isReturnedFlag
                              ? '#ccc'
                              : theme.tc1,
                            // borderLeft: `4px solid ${
                            //   isSelected
                            //     ? isSettledFlag
                            //       ? theme.s
                            //       : isReturnedFlag
                            //       ? '#ccc'
                            //       : theme.c1
                            //     : isSettledFlag
                            //     ? theme.s
                            //     : 'transparent'
                            // }`,
                            fontWeight: isSelected ? 'bold' : 'normal',
                          },
                        },
                        children:
                          treatment?.treatmentType == '1' ||
                          treatment?.treatmentType == '2'
                            ? getRecipeCategoryName(r.category) + '（外配）'
                            : getRecipeCategoryName(r.category) +
                              (isSettledFlag
                                ? '（完）'
                                : isReturnedFlag
                                ? '（退）'
                                : ''),
                      }
                    },
                  },
                  {
                    title: '开单信息',
                    key: 'amount',
                    align: 'right',
                    render: function Element(_, r) {
                      const isSelected = r.id == currentRecipe?.id
                      const isSettledFlag = r.state === RecipeStatus.Settled
                      const isReturnedFlag = r.state === RecipeStatus.Returned
                      return (
                        <span
                          style={{
                            color: isSelected
                              ? isSettledFlag
                                ? theme.s
                                : isReturnedFlag
                                ? '#ccc'
                                : theme.c1
                              : isReturnedFlag
                              ? '#ccc'
                              : theme.tc1,
                          }}
                        >
                          {moment(r.recipeTime).format('HH:mm')}
                        </span>
                      )
                    },
                  },
                ]}
                dataSource={recipes}
                pagination={false}
                rowKey={(r) => r.id}
                onRow={(r) => ({
                  onClick: () => setCurrentRecipe(r),
                })}
                rowSelection={{
                  selectedRowKeys: selectedRecipes.map((r) => r.id),
                  onChange: (ks) => {
                    const ids = ks as string[]
                    setSelectedRecipes(
                      recipes.filter((r: any) => ids.find((id) => id === r.id))
                    )
                  },
                  getCheckboxProps: (record:any) => ({
                    // disabled: false,
                    disabled:record.state === RecipeStatus.Settled || record.state === RecipeStatus.Returned ? true :false, // Column configuration not to be checked
                  }),
                }}
                style={{ padding: '0 10px', flex: 1, overflow: 'auto' }}
              />
            </Col>
          </TabPane>
          <TabPane
            tab={<span style={{ fontSize: '1.25rem' }}>病历信息</span>}
            key='1'
          >
            <Col className={styles.history}>
              <Card title='疾病信息'>
                {treatment?.disease?.split(',')?.map((d, i) => (
                  <div key={i}>{d}</div>
                ))}
              </Card>
              <Card title='诊断描述'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.treatmentConclusion}
                </div>
              </Card>
              {/* <Card title='体格检查'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.patientTemperature &&
                    treatment?.patientTemperature + '℃，'}
                  {treatment?.patientSystolicPressure &&
                    treatment?.patientSystolicPressure + '/'}
                  {treatment?.patientDiastolicPressure &&
                    treatment?.patientDiastolicPressure + 'mmHg，'}
                  {treatment?.patientPulse &&
                    treatment?.patientPulse + '次/分，'}
                  {treatment?.patientHeight &&
                    treatment?.patientHeight + 'cm，'}
                  {treatment?.patientWeight &&
                    treatment?.patientWeight + 'kg，'}
                  {treatment?.patientWeight && treatment?.patientHeight
                    ? 'BMI:' +
                      (
                        (treatment?.patientWeight /
                          (treatment?.patientHeight *
                            treatment?.patientHeight)) *
                        10000
                      ).toFixed(1) +
                      '，'
                    : ''}
                  {treatment?.physicalExamination}
                </div>
              </Card>
              <Card title='辅助检查'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.inspectionCheck}
                </div>
              </Card> */}
              <Card title='现病史'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.historyOfPresentIllness}
                </div>
              </Card>
              <Card title='既往史'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.pastMedicalHistory}
                </div>
              </Card>
              <Card title='主诉'>
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                  {treatment?.chiefComplaint}
                </div>
              </Card>
            </Col>
          </TabPane>
        </Tabs>
      </Col>
      <Col
        flex={1}
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: readMode ? 10 : 20,
          backgroundColor: theme.pn,
          borderRadius: readMode ? `0 0 ${theme.br}px 0` : `${theme.br}px`,
          overflowY: 'hidden',
        }}
      >
        <Row
          align='middle'
          style={{
            position: hisVersion == 1 && ('fixed' as any),
            height: '3.5rem',
            padding: '0 20px',
            color: theme.tc1,
            fontSize: '1rem',
          }}
        >
          <Col span={21}>
            <Row>
              <div style={{ whiteSpace: 'nowrap' }}>
                所选处方 编号:{' '}
                <span
                  style={{
                    color: theme.tc1,
                    fontWeight: 'bold',
                  }}
                >
                  {currentRecipe?.id}
                </span>
                {' '}，类型:{' '}
                <span
                  style={{
                    color: theme.tc1,
                    fontWeight: 'bold',
                  }}
                >
                  {currentRecipe
                    ? getRecipeCategoryName(currentRecipe.category)
                    : ''}
                </span>
                {' '}，开方时间:{' '}
                <span
                  style={{
                    color: theme.tc1,
                    fontWeight: 'bold',
                  }}
                >
                  {currentRecipe?.recipeTime}
                </span>
              </div>
              {isSetting && (
                <div>
                  ，代煎类别:{' '}
                  <span
                    style={{
                      color:
                        machiningTypeMsg == '委外代煎袋装液体'
                          ? 'red'
                          : theme.tc1,
                      fontWeight: 'bold',
                    }}
                  >
                    {machiningTypeMsg}
                  </span>
                </div>
              )}
            </Row>
          </Col>
          <Col span={3}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                color: '#027AFF',
              }}
            >
              {hisVersion != 1 &&
                treatment &&
                treatment?.insuranceCode &&
                treatment?.insuranceCode != 'ZIFEI' &&
                apiUserType !== 'SYLD' &&
                recipes?.find((v: any) => v?.id == currentRecipe?.id)?.state !==
                  RecipeStatus.Settled &&
                recipes?.find((v: any) => v?.id == currentRecipe?.id)?.state !==
                  RecipeStatus.Returned && (
                  <a
                    onClick={() => {
                      Modal.confirm({
                        title: '',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;
                            医保转自费后，该患者本次就诊的所有费用的收费类型都将改成自费结算，请确认此操作!
                            <div>
                              如只需调整某一个药品或处方单的收费类型,请去单独修改药品的收费类型。
                            </div>
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          dispatch(
                            getInsuranceToSelfpay({
                              registrationId: treatment?.registration?.id,
                              treatmentId: treatmentId,
                              patientName: treatment?.patientName,
                            })
                          )
                            .then(unwrapResult)
                            .then((v: any) => {
                              notification.success({
                                message: '操作成功',
                              })
                              getTreatmentData()
                            })
                        },
                      })
                    }}
                  >
                    医保转自费
                  </a>
                )}
              {hisVersion != 1 &&
                treatment &&
                insuranceArray.length !== 0 &&
                treatment?.insuranceCode &&
                apiUserType !== 'SYLD' &&
                treatment?.insuranceCode == 'ZIFEI' &&
                recipes?.find((v: any) => v?.id == currentRecipe?.id)?.state !==
                  RecipeStatus.Settled &&
                recipes?.find((v: any) => v?.id == currentRecipe?.id)?.state !==
                  RecipeStatus.Returned && (
                  <a
                    onClick={() => {
                      setRegistrationForConvert(treatment?.registration)
                    }}
                  >
                    自费转医保
                  </a>
                )}
            </div>
          </Col>
        </Row>
        <Row
          style={{
            minWidth: '1249px',
            height: '3.125rem',
            padding: '0 10px',
            marginRight: '20px',
            backgroundColor: theme.th,
            marginLeft: 20,
            position: hisVersion == 1 && ('relative' as any),
            top: hisVersion == 1 && ('56px' as any),
          }}
          justify={'space-between'}
        >
          <Space
            style={
              {
                // position: hisVersion == 1 ? ('fixed' as any) : '',
                // top: hisVersion == 1 ? ('240px' as any) : '',
              }
            }
          >
            {!readMode && (
              <Button
                danger
                type='primary'
                disabled={selectedMaterialIds.length === 0}
                onClick={() => {
                  if (!currentRecipe || selectedMaterialIds.length === 0) {
                    return
                  }
                  Modal.confirm({
                    title: '提示',
                    content: '确定删除选中的药品？',
                    cancelText: '取消',
                    okText: '确认',
                    onOk: () =>
                      dispatch(removeMaterials({ids: selectedMaterialIds}))
                        .then(unwrapResult)
                        .then(() => {
                          if (
                            selectedMaterialIds.includes(replaceMakeId) &&
                            isSetting
                          ) {
                            dispatch(
                              isdeleteReplaceMakeSetting({
                                status: 1,
                                id: setID,
                              })
                            )
                          }
                          if (currentRecipe) {
                            dispatch(getMaterialList(currentRecipe.id))
                          }
                        })
                        .catch(() => {
                          // do nothing.
                        }),
                  })
                }}
              >
                删除选中行
              </Button>
            )}
            <Button
              type='primary'
              onClick={() => {
                if (currentRecipe?.id) {
                  getReciptPrintList()
                }
                setPrintTemplateCategory(PrintTemplateCategory.Zxd)
              }}
            >
              打印执行单
            </Button>
            {currentRecipe?.category !== RecipeCategory.Tcm &&
              currentRecipe?.category !== RecipeCategory.TcmGranules && (
                <Dropdown
                  trigger={['click']}
                  overlay={
                    <Row
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: 15,
                      }}
                    >
                      <Space direction='vertical' size='large'>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(
                              PrintTemplateCategory.JXJY
                            )
                          }
                        >
                          新版处方单(适用打印偏好设置)
                        </Button>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(PrintTemplateCategory.Xyy)
                          }
                        >
                          有诊疗
                          <span style={{ fontSize: '12px' }}>
                            (每页最多5个药品)
                          </span>
                        </Button>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(PrintTemplateCategory.Xyw)
                          }
                        >
                          无诊疗
                          <span style={{ fontSize: '12px' }}>
                            (每页最多5个药品)
                          </span>
                        </Button>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(
                              PrintTemplateCategory.Xycfjwzl
                            )
                          }
                        >
                          有诊疗
                          <span style={{ fontSize: '12px' }}>
                            (每页最多8个药品)
                          </span>
                        </Button>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(
                              PrintTemplateCategory.Xycfjyzl
                            )
                          }
                        >
                          无诊疗
                          <span style={{ fontSize: '12px' }}>
                            (每页最多8个药品)
                          </span>
                        </Button>
                        <Button
                          type='primary'
                          onClick={() => {
                            // if (treatment?.insuranceCode != 'ZIFEI') {
                            setPrintTemplateCategory(
                              PrintTemplateCategory.Ybwpcfd
                            )
                            // } else {
                            //   setPrintTemplateCategory(
                            //     PrintTemplateCategory.Zfwpcfd
                            //   )
                            // }
                          }}
                        >
                          外配处方单
                        </Button>
                        {/* <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(
                              PrintTemplateCategory.Ybwpcfd
                            )
                          }
                        >
                          {getTemplateCategoryName(
                            PrintTemplateCategory.Ybwpcfd
                          )}
                        </Button>
                        <Button
                          type='primary'
                          onClick={() =>
                            setPrintTemplateCategory(
                              PrintTemplateCategory.Zfwpcfd
                            )
                          }
                        >
                          {getTemplateCategoryName(
                            PrintTemplateCategory.Zfwpcfd
                          )}
                        </Button> */}
                      </Space>
                    </Row>
                  }
                >
                  <Button type='primary' className={styles.button}>
                    处方单打印
                  </Button>
                </Dropdown>
              )}
            {currentRecipe?.category === RecipeCategory.Tcm && (
              <Button
                type='primary'
                className={styles.button}
                onClick={() =>
                  setPrintTemplateCategory(PrintTemplateCategory.Zcy)
                }
              >
                处方单打印
              </Button>
            )}
            {treatment &&
              treatment?.insuranceCode &&
              treatment?.insuranceCode != 'ZIFEI' &&
              !isSettledFlag && (
                <>
                  <Dropdown
                    disabled={
                      selectedMaterialIds.length === 0 || outRecipeDisable
                    }
                    className={styles.button}
                    overlay={changeItemsPayType}
                    trigger={['click']}
                  >
                    <Button
                      type='primary'
                      className={styles.button}
                      loading={updateItemTypeBatchReadLoading}
                      disabled={updateItemTypeBatchReadLoading}
                    >
                      变更收费类型
                    </Button>
                  </Dropdown>
                </>
              )}
            {currentRecipe?.category === RecipeCategory.TcmGranules && (
              <Button
                type='primary'
                className={styles.button}
                onClick={() =>
                  setPrintTemplateCategory(PrintTemplateCategory.Klj)
                }
              >
                处方单打印
              </Button>
            )}
            {(currentRecipe?.category === RecipeCategory.Tcm ||
              currentRecipe?.category === RecipeCategory.TcmGranules) && (
              <Button
                style={{ border: '1px solid' }}
                type={isSetting ? 'primary' : 'link'}
                className={styles.button}
                onClick={() => {
                  setIsReplaceMakeModalVisible(true)
                }}
                disabled={
                  (currentRecipe?.state == 0 ? false : true) ||
                  replaceMakeDisable ||
                  isDisableReplaceMake
                }
              >
                代煎设置
              </Button>
            )}
          </Space>
          <Space>
            <Badge count={traceCodeCnt} showZero={true}>
              <Button
                style={{ marginTop: '4px' }}
                type='primary'
                className={styles.button}
                onClick={() => {
                  const tId = treatment?.id
                  if (tId) {
                    dispatch(getDetailWithTreatmentIDAndNoSettleAsync(tId))
                      .then(unwrapResult)
                      .then((recipeItems) => {
                        recipeItems = recipeItems.filter(
                          (item) =>
                            item.billingCategory == '01' ||
                            item.billingCategory == '02' ||
                            item.billingCategory == '17'
                        )
                        setRecipeItemList(recipeItems)
                        setShowCodeInputModal(true)
                        showCodeInputModalFlag && showCodeInputModalFlag(true)
                      })
                  } else {
                    notification.error({
                      message: '没有需要登记追溯码的药品。',
                    })
                  }
                }}
              >
                录入追溯码
              </Button>
            </Badge>
          </Space>
        </Row>
        <EditableList<Material>
          pagination={false}
          bordered
          columns={
            currentRecipe?.category === RecipeCategory.Tcm ||
            currentRecipe?.category === RecipeCategory.TcmGranules
              ? TcmColumns(
                  theme,
                  () => {},
                  false,
                  (itemPayType, v) => {
                    dispatch(
                      updateItemPayTypeAsync({
                        itemPayType,
                        recipeItemId: v.id,
                      })
                    )
                      .then(unwrapResult)
                      .then(() => {
                        setUpdateFlags('1', '1')
                        getRecipeListData()
                        dispatch(getMaterialList(currentRecipe?.id || ''))
                      })
                  },
                  '',
                  () => {},
                  readMode,
                  insuranceArray,
                  expiredInDaysEyeFlag,
                  (v: any) => {
                    setExpiredInDaysEyeFlag(v)
                    localStorage.setItem('expiredInDaysEyeFlag', v)
                  }
                )
              : currentRecipe?.category === RecipeCategory.Dispose
              ? DisposeColumns(
                  theme,
                  materials,
                  () => {},
                  false,
                  (itemPayType, v) => {
                    dispatch(
                      updateItemPayTypeAsync({
                        itemPayType,
                        recipeItemId: v.id,
                      })
                    )
                      .then(unwrapResult)
                      .then((res) => {
                        getRecipeListData()
                        dispatch(getMaterialList(currentRecipe?.id || ''))
                        setUpdateFlags('1', '1')
                      })
                  },
                  false,
                  (t, v, tooth, toothType) => {},
                  (v) => {},
                  false,
                  expiredInDaysEyeFlag,
                  (v: any) => {
                    setExpiredInDaysEyeFlag(v)
                    localStorage.setItem('expiredInDaysEyeFlag', v)
                  }
                )
              : MedicineMaterialColumns(
                  theme,
                  materials,
                  () => {},
                  false,
                  (itemPayType, v) => {
                    dispatch(
                      updateItemPayTypeAsync({
                        itemPayType,
                        recipeItemId: v.id,
                      })
                    )
                      .then(unwrapResult)
                      .then(() => {
                        getRecipeListData()
                        setUpdateFlags('1', '1')
                        dispatch(getMaterialList(currentRecipe?.id || ''))
                      })
                  },
                  false,
                  (t, v) => {
                    if (t === 'tzps') {
                      const data = {
                        patientId: Number(currentRecipe?.patientId),
                        recipeId: v.recipeId,
                        skinTestInfo: v.skinTestInfo,
                        tenantRecipeItemId: v.id,
                      }
                      dispatch(editST(data))
                        .then(unwrapResult)
                        .then((res: any) => {
                          if (
                            v?.skinTestInfo != '续用' &&
                            v?.skinTestInfo != '免皮'
                          ) {
                            notification.success({
                              message: '通知成功',
                            })
                          }
                        })
                    }
                  },
                  readMode,
                  ()=>{},
                  expiredInDaysEyeFlag,
                  (v: any) => {
                    setExpiredInDaysEyeFlag(v)
                    localStorage.setItem('expiredInDaysEyeFlag', v)
                  }
                )
          }
          dataSource={materials}
          loading={pageLoading}
          rowKey={(m) => m.id}
          rowSelection={
            noCheckBox
              ? (null as any)
              : {
                  selectedRowKeys: selectedMaterialIds,
                  onChange: (ks) => setSelectedMaterialIds(ks as string[]),
                }
          }
          style={{
            flex: 1,
            margin:
              hisVersion == 1 ? '56px 20px 10px 20px' : '0 20px 10px 20px',
            minWidth: 1250,
            overflow: 'auto',
          }}
        />
        {currentRecipe?.category === RecipeCategory.Tcm && (
          <Row
            align='middle'
            className={styles.tip}
            style={{
              color: theme.tc2,
              fontSize: '0.875rem',
              padding: '0 20px 20px 20px',
              position: 'relative',
              top: '10px',
              // width: '100vw',
            }}
          >
            总帖均：
            <div
              style={{
                color: theme.tc1,
                fontSize: '1.125rem',
                marginRight: 10,
              }}
            >
              ¥{selectedRecipesZY?.[0]?.totalTipAmount?.toFixed(2)}
            </div>
            自费帖均：
            <div
              style={{
                color: theme.tc1,
                fontSize: '1.125rem',
                marginRight: 10,
              }}
            >
              ¥ {selectedRecipesZY?.[0]?.zifeiTipAmount?.toFixed(2)}
            </div>
            {currentRecipe?.category === RecipeCategory.Tcm &&
              JSON.parse(localStorage.getItem('credentials') as string)
                .insuranceArray.length != 0 && (
                <>
                  医保帖均：
                  <div
                    style={{
                      color: theme.tc1,
                      fontSize: '1.125rem',
                      marginRight: 10,
                    }}
                  >
                    ¥{selectedRecipesZY?.[0]?.insuranceTipAmount?.toFixed(2)}
                  </div>
                </>
              )}
            {isSetting ? (
              <>
                代煎类别：
                <div
                  style={{
                    color:
                      machiningTypeMsg == '委外代煎袋装液体'
                        ? 'red'
                        : theme.tc1,
                    marginRight: 10,
                  }}
                >
                  {machiningTypeMsg}
                </div>
              </>
            ) : (
              ''
            )}
            中药帖数：
            <Button
              icon={<MinusOutlined />}
              onClick={() => {
                if (currentRecipe) {
                  const v = tipCount - 1
                  if (v > 0) {
                    dispatch(
                      createOrUpdateRecipe({
                        ...currentRecipe,
                        tip: v,
                        useMethod: recipeUseMethod.join(','),
                      } as Recipe)
                    )
                      .then(unwrapResult)
                      .then((recipeId) => {
                        setTipCount(v)
                        getRecipeListData()
                        // dispatch(getMaterialList(currentRecipe?.id || ''))
                        //   .then(unwrapResult)
                        //   .then((v: any) => {
                        //     setCurrentRecipeId(v?.[0]?.recipeId?.toString())
                        //   })
                      })
                  }
                }
              }}
            />
            <InputNumber
              style={{
                width: '3.5rem',
                color: theme.tc2,
                fontSize: '1rem',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
              controls={false}
              value={tipCount}
              min={1}
              max={9999}
              bordered={false}
              onChange={(v) => {
                if (v) {
                  if (currentRecipe) {
                    dispatch(
                      createOrUpdateRecipe({
                        ...currentRecipe,
                        tip: v,
                        useMethod: recipeUseMethod.join(','),
                      } as Recipe)
                    )
                      .then(unwrapResult)
                      .then((recipeId) => {
                        setTipCount(v)
                        getRecipeListData()
                        // dispatch(getMaterialList(currentRecipe?.id || ''))
                        //   .then(unwrapResult)
                        //   .then((v: any) => {
                        //     setCurrentRecipeId(v?.[0]?.recipeId?.toString())
                        //   })
                      })
                  }
                } else {
                  setTipCount(undefined)
                }
              }}
            />
            {/* <span style={{ width: '50px', textAlign: 'center' }}>
              {selectedRecipesZY?.[0]?.tip || tipCount}
            </span> */}
            <Button
              icon={<PlusOutlined />}
              style={{ marginRight: 10 }}
              onClick={() => {
                if (currentRecipe) {
                  const v = tipCount + 1
                  dispatch(
                    createOrUpdateRecipe({
                      ...currentRecipe,
                      tip: v,
                      useMethod: recipeUseMethod.join(','),
                    } as Recipe)
                  )
                    .then(unwrapResult)
                    .then((recipeId) => {
                      setTipCount(v)
                      getRecipeListData()
                      // dispatch(getMaterialList(currentRecipe?.id || ''))
                      //   .then(unwrapResult)
                      //   .then((v: any) => {
                      //     setCurrentRecipeId(v?.[0]?.recipeId?.toString())
                      //   })
                    })
                }
              }}
            />
            处方用法：
            <Button
              disabled
              style={{ color: theme.tc2, width: '500px', textAlign: 'left' }}
              icon={<SearchOutlined color={theme.c3} />}
            >
              <span
                style={{
                  width: '500px',
                }}
              >
                {selectedRecipesZY?.[0]?.useMethod + (fValue ? fValue : '')}
                <span style={{ fontWeight: 'bold', color: '#000000' }}>
                  {fRemark ? fRemark : ''}
                </span>
              </span>
            </Button>
          </Row>
        )}
      </Col>

      <PrintTemplateModal
        printZXDData={printZXDData}
        pagePrintFlag={'zxdPrint'}
        recipeCategory={currentRecipe?.category} //处方类型
        patientId={Number(currentRecipe?.patientId)}
        visible={!!printTemplateCategory}
        templateCategory={printTemplateCategory}
        recipeId={currentRecipe?.id}
        treatmentId={treatmentId || treatmentIds}
        onCancel={() => setPrintTemplateCategory(undefined)}
        onOk={() => setPrintTemplateCategory(undefined)}
      />
      {/* <ReplaceMakeSettingModal
        visible={isReplaceMakeModalVisible}
        isOpenPriceRatio={isOpenPriceRatio}
        recipeId={Number(currentRecipe?.id)} //处方id
        recipeCategory={currentRecipe?.category} //处方类型
        patientId={Number(currentRecipe?.patientId)} // 患者ID
        isSetting={isSetting} // 是否设置过代煎
        potionType={potionType} // 上次代煎的方式
        isOpenReplaceMake={isOpenReplaceMake} // 是否开启代煎
        // isShowReplaceMakeTable={isShowReplaceMakeTable}
        onCancel={() => {
          setIsReplaceMakeModalVisible(false)
        }}
        onOk={() => {
          setIsReplaceMakeModalVisible(false)
        }}
      /> */}

      <TraceCodeInputModal
        showCodeInputModal={showCodeInputModal}
        beforeCharge={true}
        paymentResult={recipeItemList}
        treatId={treatment?.id}
        onCancel={() => {
          setShowCodeInputModal(false) 
          showCodeInputModalFlag && showCodeInputModalFlag(false)
        }}
        onOk={() => {
          setShowCodeInputModal(false)
          showCodeInputModalFlag && showCodeInputModalFlag(false)
          getTraceCodeCnt()
        }}
        isShowUpload={false}
        showUploadBtn={false}
      />

      {/* 代煎设置 */}
      <DecoctingSettingModal
        isSetting={isSetting} // 是否设置过代煎
        visible={isReplaceMakeModalVisible}
        potionType={potionType} // 上次代煎的方式
        patientId={Number(currentRecipe?.patientId)} // 患者ID
        recipeId={Number(currentRecipe?.id)} //处方id
        recipeCategory={currentRecipe?.category} //处方类型
        isOpenReplaceMake={isOpenReplaceMake} // 是否开启代煎
        onCancel={() => {
          setIsReplaceMakeModalVisible(false)
        }}
        onOk={() => {
          setIsReplaceMakeModalVisible(false)
        }}
      ></DecoctingSettingModal>
      <Modal
        title='自费转医保'
        visible={registrationForConvert != null}
        onCancel={() => setRegistrationForConvert(null)}
        footer={null}
      >
        <span>
          您正在操作
          <span style={{ fontWeight: 'bold' }}>
            {' '}
            [{registrationForConvert?.patientName}]
          </span>{' '}
          的自费转医保，请先读卡。
        </span>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
          }}
        >
          <Button
            loading={readCardLoading}
            style={{
              marginRight: '14px',
            }}
            type='primary'
            onClick={() => {
              readCard(3)
            }}
          >
            读实体卡
          </Button>
          <Button
            loading={readCardLoading}
            style={{
              marginRight: '14px',
            }}
            type='primary'
            onClick={() => {
              readCard(1)
            }}
          >
            读电子凭证
          </Button>
          {insuranceArray[0]?.ybFaceRecognition == 1 &&
              <Button
                  loading={readCardLoading}
                  style={{
                    marginRight: '14px',
                  }}
                  type='primary'
                  onClick={() => {
                    readCard(11)
                  }}
              >
                  医保刷脸
              </Button>}

          <Button
            style={{
              marginRight: '14px',
            }}
            onClick={() => {
              setRegistrationForConvert(null)
            }}
          >
            取消
          </Button>
        </Row>
      </Modal>
    </Row>
  )
}
